export default "__VITE_ASSET__DsznndLg__"